import { render } from "./GridBody.vue?vue&type=template&id=a10a421c&ts=true"
import script from "./GridBody.vue?vue&type=script&lang=tsx"
export * from "./GridBody.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__